import React, { useRef, useState } from "react";
import {
  InputDropDown,
  ProfileEditIcon,
  WorkflowItemRightArrow,
} from "../common/Icon";
import { useStateProvider } from "../common/StateProvider";
import { todayWorkflowContactData } from "../common/Helper";

const WorkflowProfileInformation = ({ setProfileToggle }) => {
  const { todaysWorkflowIndex } = useStateProvider();
  const [updateNames, setUpdateNames] = useState({
    firstName: "",
    lastName: "",
    contactType: "",
  });
  const onSaveHandler = () => {
    const updatedTodayProductivityCards = [...todayWorkflowContactData];
    updatedTodayProductivityCards[todaysWorkflowIndex].newContactNameText =
      updateNames.firstName + " " + updateNames.lastName;

    // =====================================
    setProfileToggle(false);
  };
  const activeInput = useRef();
  const onEditHandler = () => {
    activeInput.current.focus();
  };
  const submitHandler = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className="px-6 pt-9 pb-7 h-full flex flex-col md:flex-row">
        <form
          onSubmit={(e) => submitHandler(e)}
          className=" flex flex-col justify-between">
          <div>
            <div className=" flex flex-wrap w-full">
              {" "}
              <div className="flex flex-col md:flex-row gap-4 md:gap-8 w-full">
                <div className="w-full md:w-1/2">
                  <label className="text-[14px] font-normal text-black opacity-80">
                    First Name
                  </label>
                  <input
                    ref={activeInput}
                    value={updateNames.firstName}
                    onChange={(e) =>
                      setUpdateNames({
                        ...updateNames,
                        firstName: e.target.value,
                      })
                    }
                    className="text-[14px] font-normal text-black placeholder:text-gray rounded mt-2 border border-solid border-[rgba(146,_146,_146,_0.15)] px-[10px] py-[8px] outline-primary w-full"
                    type="text"
                    placeholder="First Name"
                    required
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <label className="text-[14px] font-normal text-black opacity-80">
                    Last Name
                  </label>
                  <input
                    value={updateNames.lastName}
                    onChange={(e) =>
                      setUpdateNames({
                        ...updateNames,
                        lastName: e.target.value,
                      })
                    }
                    className="text-[14px] font-normal text-black placeholder:text-gray rounded mt-2 border border-solid border-[rgba(146,_146,_146,_0.15)] px-[10px] py-[8px] outline-primary w-full"
                    type="text"
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-4 md:gap-8 pt-4 w-full">
                <div className="w-full md:w-1/2">
                  <label className="text-[14px] font-normal text-black opacity-80">
                    Contact Type
                  </label>
                  <input
                    value={updateNames.contactType}
                    onChange={(e) =>
                      setUpdateNames({
                        ...updateNames,
                        contactType: e.target.value,
                      })
                    }
                    className="text-[14px] font-normal text-black placeholder:text-gray rounded mt-2 border border-solid border-[rgba(146,_146,_146,_0.15)] px-[10px] py-[8px] outline-primary w-full"
                    type="text"
                    placeholder="Contact Type"
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <label className="text-[14px] font-normal text-black opacity-80">
                    Phone Number
                  </label>
                  <div className=" border border-solid border-[rgba(146,_146,_146,_0.15)] rounded flex justify-between items-center relative mt-2">
                    <input
                      className="text-[14px] !appearance-none font-normal text-black placeholder:text-gray  outline-primary rounded px-[10px]  py-[8px]  w-full "
                      type="number"
                      placeholder="Phone Number"
                    />
                    {/* <span className=" absolute right-0 ">
                    <InputDropDown />
                  </span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full pt-4">
              <label className="text-[14px] font-normal text-black opacity-80">
                Email Address
              </label>
              <input
                className="text-[14px] font-normal text-black placeholder:text-gray rounded mt-2 border border-solid border-[rgba(146,_146,_146,_0.15)] px-[10px] py-[8px] outline-primary w-full"
                type="email"
                placeholder="Your Email"
              />
            </div>
            <div className="w-full pt-4">
              <label className="text-[14px] font-normal text-black opacity-80">
                Address
              </label>
              <input
                className="text-[14px] font-normal text-black placeholder:text-gray rounded mt-2 border border-solid border-[rgba(146,_146,_146,_0.15)] px-[10px] py-[8px] outline-primary w-full"
                type="text"
                placeholder="Your Address"
              />
            </div>
          </div>
          <div className="flex py-7 md:pt-7 xl:pt-0  md:py-0">
            <button
              onClick={onEditHandler}
              type="submit"
              className="text-[14px] mr-2.5 font-bold text-primary rounded-[26px] border border-solid border-primary outline-none p-[6px_24px] flex items-center gap-[5px] hover:border-transparent hover:bg-new_purpal hover:text-white information_edit_button duration-200">
              <span className="information_edit_icon w-[16px] h-[16px]">
                <ProfileEditIcon />
              </span>
              Edit
            </button>
            <button
              onClick={(e) => onSaveHandler(e)}
              className="save_contact_btn ml-2.5 text-[14px] font-semibold text-white rounded-[26px] border  border-solid  border-transparent  outline-none p-[14px_25px] bg-primary flex items-center hover:bg-white hover:border-primary hover:text-primary duration-200">
              Save Contact
              <span className="save_contact_arrow">
                <WorkflowItemRightArrow />
              </span>
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default WorkflowProfileInformation;
